export default __webpack_public_path__ + "static/media/photo--sm--30.31d5d89c.jpg";